import React from 'react';
import PropTypes from 'prop-types';
import './Modal.css';

export function Modal({
  title, bodyText, show, onClose, onSubmit,
}) {
  if (show) {
    return (
      <div className="teste">
        <div className="modalContent">
          <div className="modalHeader">{title}</div>
          <div className="modalBody">{bodyText}</div>
          <div className="modalFooter">
            <button className="cancelButton" onClick={onClose}>Cancelar</button>
            <button className="acceptButton" onClick={onSubmit}>Sim</button>
          </div>
        </div>
      </div>
    );
  }
  return null;
}

Modal.propTypes = {
  title: PropTypes.string.isRequired,
  bodyText: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};
